export default "__VITE_ASSET__CA44LQNt__"